import React from 'react';
import { makeStyles, createStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { useStyles } from '../style/style';

const LoadingDashboard = () => {
  const classes = useStyles();
  return (
    <div className={classes.rootLoading}>
      <CircularProgress />
      <p>Por favor espere</p>
    </div>
  );
};

export default LoadingDashboard;
